// Estimat-kategorier och arbetsmoment baserat på Excel-strukturen
export const ESTIMAT_CATEGORIES = {
  projektering: {
    name: 'Projektering',
    color: 'bg-gray-600',
    items: [
      { name: 'Leadmes inredningsarkitekt', unit: 'h', price: 1400, defaultQuantity: 0 },
      { name: 'Konstruktör', unit: 'st', price: 15000, defaultQuantity: 0 },
      { name: 'Arkitekt', unit: 'st', price: 15000, defaultQuantity: 0 },
      { name: 'VVS', unit: 'st', price: 10000, defaultQuantity: 0 },
      { name: 'Akustik', unit: 'st', price: 10000, defaultQuantity: 0 },
      { name: 'Brand', unit: 'st', price: 10000, defaultQuantity: 0 },
      { name: 'Bygglov/anmälan', unit: 'st', price: 10000, defaultQuantity: 0 }
    ]
  },
  byggoffert: {
    name: 'Byggoffert generalentreprenör',
    color: 'bg-gray-600',
    subcategories: {
      invändigt: {
        name: 'Invändigt',
        items: [
          { name: 'Rivning', unit: 'h', price: 620, defaultQuantity: 0 },
          { name: 'Sanering', unit: 'st', price: 10000, defaultQuantity: 0 },
          { name: 'Badrum - litet', unit: 'st', price: 220000, defaultQuantity: 0 },
          { name: 'Badrum - medel', unit: 'st', price: 250000, defaultQuantity: 0 },
          { name: 'Badrum - stort', unit: 'st', price: 300000, defaultQuantity: 0 },
          { name: 'WC', unit: 'st', price: 90000, defaultQuantity: 0 },
          { name: 'Tvättstuga', unit: 'st', price: 150000, defaultQuantity: 0 },
          { name: 'Bastu', unit: 'st', price: 75000, defaultQuantity: 0 },
          { name: 'Kök', unit: 'st', price: 150000, defaultQuantity: 0 },
          { name: 'Avväxling', unit: 'st', price: 50000, defaultQuantity: 0 },
          { name: 'Innerväggar', unit: 'lpm', price: 4000, defaultQuantity: 0 },
          { name: 'Dörrar', unit: 'st', price: 1000, defaultQuantity: 0 },
          { name: 'Innertak', unit: 'kvm', price: 1000, defaultQuantity: 0 },
          { name: 'OSB+gips', unit: 'kvm', price: 1000, defaultQuantity: 0 },
          { name: 'Garderober', unit: 'st', price: 1500, defaultQuantity: 0 },
          { name: 'Platsbyggnationer', unit: 'st', price: 10000, defaultQuantity: 0 },
          { name: 'Måleri, enkel', unit: 'kvm', price: 1500, defaultQuantity: 0 },
          { name: 'Måleri, större', unit: 'kvm', price: 2500, defaultQuantity: 0 },
          { name: 'Undergolv', unit: 'kvm', price: 1000, defaultQuantity: 0 },
          { name: 'Golvläggning', unit: 'kvm', price: 750, defaultQuantity: 0 },
          { name: 'Fiskben', unit: 'kvm', price: 2700, defaultQuantity: 0 },
          { name: 'El (central, uttag, brytare)', unit: 'kvm', price: 1700, defaultQuantity: 0 },
          { name: 'Stambyte', unit: 'st', price: 20000, defaultQuantity: 0 },
          { name: 'Vattenburen golvvärme', unit: 'kvm', price: 2500, defaultQuantity: 0 },
          { name: 'Värmesystem med radiatorer', unit: 'kvm', price: 1500, defaultQuantity: 0 },
          { name: 'Värmepump/teknikrum', unit: 'st', price: 20000, defaultQuantity: 0 },
          { name: 'Källargrund', unit: 'kvm', price: 7000, defaultQuantity: 0 },
          { name: 'Ventilerat golv/vägg', unit: 'kvm', price: 1200, defaultQuantity: 0 }
        ]
      },
      utvändigt: {
        name: 'Utvändigt',
        items: [
          { name: 'Markarbete', unit: 'st', price: 10000, defaultQuantity: 0 },
          { name: 'Tillbyggnad trä', unit: 'kvm', price: 35000, defaultQuantity: 0 },
          { name: 'Tillbyggnad trä stomme', unit: 'kvm', price: 25000, defaultQuantity: 0 },
          { name: 'Tillbyggnad puts', unit: 'kvm', price: 40000, defaultQuantity: 0 },
          { name: 'Tillbyggnad puts stomme', unit: 'kvm', price: 30000, defaultQuantity: 0 },
          { name: 'Yttertak', unit: 'kvm', price: 2000, defaultQuantity: 0 },
          { name: 'Takkupa liten (3 st takstolar)', unit: 'st', price: 75000, defaultQuantity: 0 },
          { name: 'Takkupa större (4-5 st takstolar)', unit: 'st', price: 125000, defaultQuantity: 0 },
          { name: 'Gjuta & stensätta entretrappa', unit: 'steg', price: 16000, defaultQuantity: 0 },
          { name: 'Fasad', unit: 'kvm', price: 2000, defaultQuantity: 0 },
          { name: 'Putsad fasad', unit: 'kvm', price: 3000, defaultQuantity: 0 },
          { name: 'Fönster', unit: 'st', price: 1500, defaultQuantity: 0 },
          { name: 'Altan (ribb eller kryssräcke max 1,5m ovan mark)', unit: 'kvm', price: 2500, defaultQuantity: 0 },
          { name: 'Ställning mindre villa (10 veckor)', unit: 'st', price: 80000, defaultQuantity: 0 },
          { name: 'Ställning större villa (10 veckor)', unit: 'st', price: 110000, defaultQuantity: 0 }
        ]
      }
    }
  },
  sidoentreprenorer: {
    name: 'Sidoentreprenörer/specialister',
    color: 'bg-gray-600',
    items: [
      { name: 'Bergvärme med borrning och panna för mindre hus (upp till 200kvm)', unit: 'st', price: 300000, defaultQuantity: 0 },
      { name: 'bergvärme med borrning och panna för större hus (200 kvm+)', unit: 'st', price: 350000, defaultQuantity: 0 },
      { name: 'FTX mindre villa (upp till 150 kvm)', unit: 'st', price: 140000, defaultQuantity: 0 },
      { name: 'FTX större villa (mellan 150-300 kvm)', unit: 'st', price: 200000, defaultQuantity: 0 },
      { name: 'Luftvärmepump med en innendel', unit: 'st', price: 17500, defaultQuantity: 0 },
      { name: 'Luftvärmepump med två innedelar', unit: 'st', price: 28500, defaultQuantity: 0 },
      { name: 'Värmepump', unit: 'st', price: 150000, defaultQuantity: 0 },
      { name: 'Ventilation', unit: 'st', price: 150000, defaultQuantity: 0 },
      { name: 'Smarta hem/automatik', unit: 'kvm', price: 5000, defaultQuantity: 0 }
    ]
  },
  inkopFastInredning: {
    name: 'Inköp fast inredning',
    color: 'bg-gray-600',
    items: [
      { name: 'Fönster', unit: 'st', price: 10000, defaultQuantity: 0 },
      { name: 'Dörrar', unit: 'st', price: 2000, defaultQuantity: 0 },
      { name: 'Ytterdörr', unit: 'st', price: 15000, defaultQuantity: 0 },
      { name: 'Fönsterdörr', unit: 'st', price: 15000, defaultQuantity: 0 },
      { name: 'Klinkergolv', unit: 'kvm', price: 1000, defaultQuantity: 0 },
      { name: 'Kakel/klinker & badrumsinredning', unit: 'st', price: 60000, defaultQuantity: 0 },
      { name: 'Kök IKEA', unit: 'st', price: 150000, defaultQuantity: 0 },
      { name: 'Kök Ballingslöv', unit: 'st', price: 300000, defaultQuantity: 0 },
      { name: 'Kök Platsbeställt', unit: 'st', price: 600000, defaultQuantity: 0 },
      { name: 'Klickgolv', unit: 'kvm', price: 800, defaultQuantity: 0 },
      {
        name: 'Garderober/förvaring',
        unit: 'st',
        price: 0,
        defaultQuantity: 0,
        useSubItemsTotal: true,
        defaultSubItems: [
          { name: 'Stommar', unit: 'st', price: 8000, defaultQuantity: 0 },
          { name: 'Täcksidor', unit: 'st', price: 2500, defaultQuantity: 0 },
          { name: 'Fronter', unit: 'st', price: 2200, defaultQuantity: 0 }
        ]
      },
      { name: 'Trappa', unit: 'st', price: 100000, defaultQuantity: 0 }
    ]
  },
  inredningsarkitekt: {
    name: 'Baspaket (internt)',
    color: 'bg-gray-600',
    defaultExpanded: true,
    subcategories: {
      ritningar2D: {
        name: 'Ritningar 2D',
        defaultExpanded: true,
        items: [
          { name: 'Plan', unit: 'st', price: 10000, defaultQuantity: 1 },
          { name: 'El', unit: 'st', price: 8000, defaultQuantity: 1 },
          { name: 'Bad', unit: 'st', price: 8000, defaultQuantity: 1 },
          { name: 'WC', unit: 'st', price: 8000, defaultQuantity: 1 },
          { name: 'Tvätt', unit: 'st', price: 8000, defaultQuantity: 1 }
        ]
      },
      fast2D: {
        name: 'Fast inredning 2D',
        defaultExpanded: true,
        items: [
          { name: 'Kök', unit: 'st', price: 10000, defaultQuantity: 1 },
          { name: 'Garderob', unit: 'st', price: 5000, defaultQuantity: 1 },
          { name: 'Bokhylla', unit: 'st', price: 10000, defaultQuantity: 1 },
          { name: 'Elementskydd', unit: 'st', price: 5000, defaultQuantity: 1 },
          { name: 'Platsbyggnation', unit: 'st', price: 1000, defaultQuantity: 1 }
        ]
      },
      design3D: {
        name: 'Design 3D',
        defaultExpanded: true,
        items: [
          // Design 3D hanteras via checkboxes i intervjuFrågor.hjälpInredningsarkitekt.design3D
          // Inga items här, bara för att visa underkategorin
        ]
      }
    }
  }
}; 